var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.data && _vm.data.length)?_c('div',[_c('Carousel',_vm._l((_vm.data),function(d){return _c('div',{key:d.id},[_c('router-link',{attrs:{"to":{
            name: 'SessionsFind',
            query: {
              type: 'sessions',
              filter: d.name,
            },
          }}},[_c('CategoryCard',{attrs:{"data":d}})],1)],1)}),0)],1):_c('span',{staticClass:"text-xs text-gray-700"},[_vm._v("No data found.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }